/* eslint-disable */
export default {
  onSearching: '載入中...',
  noContacts: '找不到記錄。',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
